import { useQuery } from "@tanstack/react-query";
import rateCardProvider from "@/providers/rate-card.provider";
import { rateCardKeys } from "./queryKeys";

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export function useGetRateCardsQuery() {
  return useQuery({
    queryKey: rateCardKeys.all(),
    queryFn: () => rateCardProvider.getRateCards(),
    staleTime: FIVE_MINUTES_MS,
  });
}
